import React from "react";
import { getBrandLogoFullSrc } from "../../layout/BrandLogo";
import authBg from "../../assets/tailwick/auth-bg.jpg";
import boxedIllustration from "../../assets/tailwick/boxed.png";
import AuthCopyright from "./AuthCopyright";

function AuthBoxedLayout({
	children,
	title,
	subtitle,
	footer,
	wide = false,
	showCopyright = true,
	testId,
	titleClassName = "text-secondary",
}) {
	const logoSrc = getBrandLogoFullSrc();
	const maxWidth = wide ? "max-w-6xl" : "max-w-5xl";

	return (
		<div
			className="tailwick-auth min-h-screen w-full flex justify-center items-center bg-cover bg-no-repeat bg-center p-4 font-sans"
			style={{ backgroundImage: `url(${authBg})` }}
			data-testid={testId}
		>
			<div className={`relative w-full ${maxWidth}`}>
				<div className="bg-card/70 rounded-lg w-full mx-auto backdrop-blur-sm">
					<div className="grid lg:grid-cols-12 grid-cols-1 items-center gap-0">
						<div className="lg:col-span-5">
							<div className="text-center px-6 sm:px-10 py-10 lg:py-12">
								<img
									alt="logo"
									src={logoSrc}
									className="lg:hidden h-10 w-auto object-contain mx-auto mb-6"
								/>
								<div className="text-center">
									{title && (
										<h4
											className={`mb-3 text-xl font-semibold ${titleClassName}`}
										>
											{title}
										</h4>
									)}
									{subtitle && (
										<p className="text-base text-default-500">{subtitle}</p>
									)}
								</div>

								<div className="text-left w-full mt-10">{children}</div>

								{footer && <div className="mt-6">{footer}</div>}

								{showCopyright && <AuthCopyright />}
							</div>
						</div>

						<div className="hidden lg:block lg:col-span-7 bg-card/60 mx-2 my-2 shadow-tailwick-panel rounded-lg">
							<div className="pt-10 px-10 h-full flex flex-col min-h-[420px]">
								<div className="flex items-center justify-between gap-3">
									<img
										alt="logo"
										src={logoSrc}
										className="h-10 w-auto object-contain"
									/>
								</div>
								<div className="mt-auto flex justify-center pb-6">
									<img
										src={boxedIllustration}
										alt=""
										className="max-w-full h-auto"
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default AuthBoxedLayout;
